import React from 'react'
import {connect} from 'react-redux'
import {selectProblem, submitAnswerGrandmaster, getGMProblem, exitGrandmaster, revealSolutionGrandmaster, viewExplanations, addAction, postBatch} from '../../../redux/modules/grandmaster'
import {showModal} from '../../../redux/modules/modal'
import {toJS} from '../../../util/ToJS'
import GrandmasterProblem from '../components/GrandmasterProblem'
import LoadingSpinner from '../../../core/components/loading-spinner/LoadingSpinner'
import {withRouter} from 'react-router'
import {wrapDispatch} from 'multireducer'
import {postToggleVote} from '../../../redux/modules/content'

class VisibleGrandmasterProblemPure extends React.PureComponent {

  componentWillUnmount() {
    const {exitGrandmaster} = this.props
    exitGrandmaster()
  }

  render() {
    const {didGetProblem, isFetching, exitGrandmaster, ...others} = this.props
    if (isFetching || !didGetProblem) {
      return (<LoadingSpinner light />)
    }
    return <GrandmasterProblem {...others} />
  }
}

const mapStateToProps = state => (selectProblem(state))

const mapDispatchToProps = dispatch => {
  return {
    submitAnswerGrandmaster: blockIndex => {
      dispatch(submitAnswerGrandmaster(blockIndex))
    },
    revealSolutionGrandmaster: blockIndex => {
      dispatch(revealSolutionGrandmaster(blockIndex))
    },
    nextProblem: (topicId) => {
      dispatch(getGMProblem(topicId,0))
      window.scrollTo(0, 0)
    },
    exitGrandmaster: () => {
      dispatch(exitGrandmaster())
    },
    viewExplanations: () => {
      dispatch(viewExplanations(true))
    },
    openShare: (topicId, contentId, type) => {
      const slug = `${window.location.origin}/s/${topicId}/problem/${contentId}`
      dispatch(showModal('SHARE',{
        type: type,
        slug: slug
      }))
    },
    toggleVote: (type,id) => wrapDispatch(dispatch, 'grandmasterProblem')(postToggleVote(type,id)),
    report: (item) => {
      dispatch(showModal('REPORT',{
        item: item,
        callback: ()=>{
          dispatch(addAction('report_problem', null))
          dispatch(postBatch())
        },
      }))
    }
  }
}

const VisibleGrandmasterProblem = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(toJS(VisibleGrandmasterProblemPure)))

export default VisibleGrandmasterProblem



// WEBPACK FOOTER //
// ./src/domains/grandmaster/containers/VisibleGrandmasterProblem.js